<template>
  <main class="bmd-layout-content">
    <!--Modal-->
    <div class="container my-4">
      <div class="table-responsive padreTabla">
        <table class="table table-hover">
          <thead>
          <tr>
            <th>
              <div class="">
                <label class="text-dark" for="nuevaCategoria">Nueva categoria <span class="text-danger">*</span></label>
                <input type="text" class="form-control" v-model="newcategoria.categoria" id="nuevaCategoria"
                       placeholder="Categoria ....." required>
              </div>
            </th>
            <th>
              <div class="custom-file col-2">
                <input type="file" class="custom-file-input col-5 hedden" id="customFile" @change="getImage"
                       accept="image/*" hidden>
                <label class="custom-file-label" for="customFile"><i class="fas fa-upload mr-1"></i>Icono</label>
              </div>
            </th>
            <th colspan="2" class="text-center">
              <div class="btn-group  d-flex justify-content-start align-items-end" role="group"
                   aria-label="Basic example">
                <button type="submit" class="btn  btn-primary " @click="actualizarCategoria"
                        v-if="paginacionCategorias.acciones.editar">Actualizar
                </button>
                <button type="submit" class="btn  btn-primary " @click="guardarCategoria" v-else>Agregar</button>
                <button type="button" class="btn btn-secondary" @click="limpiar">Cancelar</button>
              </div>
            </th>
          </tr>
          <tr></tr>
          </thead>
        </table>

        <table class="table table-hover">
          <thead>
          <tr>
            <th class="py-0" colspan="4">
              <div class="col-4 col-sm-3 col-md-2 float-sm-right mx-0 px-0">
                <select class="custom-select custom-select-sm " v-model="paginacionCategorias.selected"
                        @change="paginarCategorias">
                  <option selected>Mostrar</option>
                  <option value="5">5</option>
                  <option value="10">10</option>
                  <option value="20">20</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                  <option value="100000">Todos</option>
                </select>
              </div>
            </th>
          </tr>
          <tr>
            <th>Categorias</th>
            <th>Icono</th>
            <th>Posición</th>
            <th colspan="2" class="text-center">Acciones</th>
          </tr>
          </thead>
          <tbody>
          <tr class="py-1 my-0" v-for="categoria in categorias.data">
            <td class="py-1 my-1">{{categoria.categoria}}</td>
            <td class="py-1 my-1" v-if="categoria.iconos[0].url_icono != 'null'">
              <img :src="'http://'+categoria.iconos[0].url_icono" height="20">
            </td>
            <td class="py-1 my-1" v-else>
              <div class="text-info"><i class="fas fa-info-circle"></i>Agregar icono</div>
            </td>
            <td class="py-1 my-1">
              <button type="submit" class="btn btn-secondary btn-sm btn-outline-success py-0"
                      v-if="visibilidadposicionCategoria != categoria.id" title="Editar posición"
                      @click="editarPosicionCategorias(categoria)">{{ categoria.orden }}
              </button>
              <div class="input-group" v-else>
                <div class="input-group-prepend">
                  <button class="btn btn-outline-danger btn-sm  py-0 px-1" type="submit" title="Cancelar"
                          @click="cancelarPosicionCategoria(categoria)">
                    <i class="far fa-times-circle"></i></button>
                </div>
                <input type="number" min="0" class="py-1 input-group-sm" placeholder="0" aria-label=""
                       aria-describedby="basic-addon1"
                       style="height: 21px; width: 40px" data-toggle="tooltip" data-placement="bottom"
                       title="Agregue la posición" :onmouseover="tooltop()" v-model="categoria.orden">
                <div class="input-group-prepend">
                  <button class="btn btn-outline-primary btn-sm  py-0 px-1" type="submit" title="Guardar"
                          @click="guardarPosicionCategoria(categoria)"><i class="far fa-save"></i>
                  </button>
                </div>
              </div>
            </td>
            <td class="py-1 my-1 px-0 text-center">
              <i class="far fa-edit botonAcciones mr-5" @click="editarCategoria(categoria)" data-toggle="tooltip"
                 data-placement="left" title="Editar" :onmouseover="tooltop()"></i>

              <i class="far fa-trash-alt botonAcciones text-danger" @click="eliminarCategoria(categoria)"
                 data-toggle="tooltip" data-placement="left" title="Eliminar" :onmouseover="tooltop()"></i>
            </td>
          </tr>
          </tbody>
        </table>
        <div class="btn-toolbar d-flex justify-content-center" role="toolbar" aria-label="Toolbar with button groups">
          <div class="btn-group mr-2" role="group" aria-label="First group">
            <button type="button"
                    :class="{'disabled':paginacionCategorias.paginacion.anterior,'btn btn-secondary':true}"
                    @click="cargarCategorias(page={page: categorias.current_page - 1})">
              <i class="fas fa-arrow-left"></i> Atrás
            </button>
            <button type="button" :class="{disabled:paginacionCategorias.paginacion.siguiente,'btn btn-secondary':true}"
                    @click="cargarCategorias(page= {page: categorias.current_page + 1})">
              Siguiente<i class="fas fa-arrow-right"></i></button>
          </div>
        </div>
      </div>
    </div>
    <!--Modal-->
    <div class="container my-4">
      <div class="col-12 mb-2">
        <div class="input-group mb-3">
          <div class="">
            <label class="" for="etiquet">Añadir Etiqueta</label>
            <input type="text" class="form-control etiqueta" id="etiquet" v-model="newEtiquetas.etiqueta"
                   placeholder="Escriba la etiqueta" required>
          </div>
          <div class="input-group-append d-flex align-items-end">
            <button class="btn btn-outline-secondary pb-0 my-0 " @click="actualizarEtiqueta" type="button"
                    v-if="paginacionEtiquetas.acciones.editar">Actualizar
            </button>
            <button class="btn btn-outline-secondary pb-0 my-0 " @click="crearEtiqueta" type="button" v-else>Agregar
            </button>
            <button class="btn btn-outline-secondary pb-0 my-0 " @click="limpiarEtiqueta" type="button">Cancelar
            </button>
          </div>
        </div>
      </div>

      <div class="table-responsive padreTabla">
        <table class="table table-hover">
          <thead>
          <tr>
            <th class="py-0" colspan="4">
              <div class="col-4 col-sm-3 col-md-2 float-sm-right mx-0 px-0">
                <select class="custom-select custom-select-sm " v-model="paginacionEtiquetas.selected"
                        @change="paginarEtiquetas">
                  <option selected>Mostrar</option>
                  <option value="5">5</option>
                  <option value="10">10</option>
                  <option value="20">20</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                  <option value="100000">Todos</option>
                </select>
              </div>
            </th>
          </tr>
          <tr>
            <th>Etiquetas</th>
            <th colspan="2" class="text-center">Acciones</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="etiqueta in etiquetas.data" class="py-1 my-0">
            <td class="py-1 my-1">{{etiqueta.etiqueta}}</td>
            <td class="py-1 my-1 px-0 text-center">
              <i class="far fa-edit botonAcciones mr-5" @click="editarEtiquetas(etiqueta)" data-toggle="tooltip"
                 data-placement="left" title="Editar" :onmouseover="tooltop()">
              </i>
              <i class="far fa-trash-alt botonAcciones text-danger" @click="eliminarEtiquetas(etiqueta)"
                 data-toggle="tooltip" data-placement="left" title="Eliminar" :onmouseover="tooltop()">
              </i>
            </td>
          </tr>
          </tbody>
        </table>
        <div class="btn-toolbar d-flex justify-content-center" role="toolbar" aria-label="Toolbar with button groups">
          <div class="btn-group mr-2" role="group" aria-label="First group">
            <button type="button" :class="{'disabled':paginacionEtiquetas.paginacion.anterior,'btn btn-secondary':true}"
                    @click="cargarEtiquetas(page={page: etiquetas.current_page - 1})">
              <i class="fas fa-arrow-left"></i> Atrás
            </button>
            <button type="button" :class="{disabled:paginacionEtiquetas.paginacion.siguiente,'btn btn-secondary':true}"
                    @click="cargarEtiquetas(page= {page: etiquetas.current_page + 1})">
              Siguiente<i class="fas fa-arrow-right"></i></button>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>

  import servicioApi from '../../servicioApi';

  export default {
    name: "categorias",
    data() {
      return {
        cliente: {},
        categorias: {},
        newcategoria: {
          categoria: '',
          cliente_id: '',
          icono: '',
        },
        etiquetas: {},
        newEtiquetas: {etiqueta: '', cliente_id: ""},
        imagen: null,
        paginacionCategorias: {
          paginacionParametros: {page: '', mostrar: ''},
          paginacion: {anterior: false, siguiente: false},
          selected: 'Mostrar',
          acciones: {editar: false}
        },
        paginacionEtiquetas: {
          paginacionParametros: {page: '', mostrar: ''},
          paginacion: {anterior: false, siguiente: false},
          selected: 'Mostrar',
          acciones: {editar: false}
        },
        etiquetaSeleccionada: {
          selected: []
        },
        categoriaEtiquetas: {},
        visibilidadposicionCategoria: '',
      }
    },
    computed: {},
    created() {
      if (this.paginacionCategorias.selected == "Mostrar") {
        this.cargarCategorias({page: 1, mostrar: 10});
      }
      if (this.paginacionEtiquetas.selected == "Mostrar") {
        this.cargarEtiquetas({page: 1, mostrar: 10});
      }
      $('#myModal').on('shown.bs.modal', function () {
        $('#myInput').trigger('focus')
      })
    },
    methods: {
      tooltop() {
        $(function () {
          $('[data-toggle="tooltip"]').tooltip()
        })
      },
      editarPosicionCategorias(data) {
        console.log(data);
        this.visibilidadposicionCategoria = data.id;
        this.position = data.orden;
        console.log(this.visibilidadposicionCategoria)
      },
      guardarPosicionCategoria(data) {
        console.log(data);
        if (data.etiquetas == '')
          data.etiquetas = null;
        console.log(data)

        servicioApi.rol_regular.categorias.putOrdenCategorias(data).then(resp => {
          this.visibilidadposicionCategoria = '';
          this.cargarCategorias(this.paginacionCategorias.paginacionParametros);
        }).catch(error => {
          console.log(error);
        });
      },
      cancelarPosicionCategoria(data) {
        console.log(data);
        this.visibilidadposicionCategoria = '';
        data.orden = this.position;
      },
      crearEtiqueta: function () {
        this.newEtiquetas.cliente_id = this.cliente.id;
        servicioApi.rol_regular.etiquetas.postEtiqueta(this.newEtiquetas).then(resp => {
          this.limpiarEtiqueta();
          this.cargarEtiquetas(this.paginacionEtiquetas.paginacionParametros)
        }).catch(e => {
          console.log(e)
        })
      },
      cargarEtiquetas(parametro) {
        if (parametro.page > this.etiquetas.last_page || parametro.page < 1)
          parametro.page = this.etiquetas.last_page;
        else {
          if (this.paginacionEtiquetas.selected != 'Mostrar') {
            parametro.mostrar = this.paginacionEtiquetas.selected;
          }
          this.paginacionEtiquetas.paginacionParametros = parametro;
          servicioApi.rol_regular.etiquetas.getEtiquetas(parametro).then(response => {
            this.etiquetas = response.data.data;
            if (this.etiquetas.current_page != undefined && this.etiquetas.current_page == 1)
              this.paginacionEtiquetas.paginacion.anterior = true;
            else
              this.paginacionEtiquetas.paginacion.anterior = false;

            if (this.etiquetas.current_page != undefined && this.etiquetas.last_page != undefined && this.etiquetas.last_page == this.etiquetas.current_page)
              this.paginacionEtiquetas.paginacion.siguiente = true;
            else
              this.paginacionEtiquetas.paginacion.siguiente = false;
          }).catch(e => {
          });
        }

        servicioApi.rol_regular.etiquetas.getListaEtiquetas('lista').then(resp => {
          this.categoriaEtiquetas = resp.data;
        }).catch(e => {
        });
      },
      paginarEtiquetas: function () {
        if (this.paginacionEtiquetas.selected != 'Mostrar') {
          this.cargarEtiquetas({mostrar: this.paginacionEtiquetas.selected});
        } else
          this.cargarEtiquetas({mostrar: null});
      },
      actualizarEtiqueta: function () {
        servicioApi.rol_regular.etiquetas.putEtiqueta(this.newEtiquetas).then(resp => {
          this.limpiarEtiqueta();
          this.cargarEtiquetas(this.paginacionEtiquetas.paginacionParametros)
        }).catch(error => {
          console.log(error);
        });
      },
      eliminarEtiquetas: function (etiqueta) {
        servicioApi.rol_regular.etiquetas.Delete(etiqueta).then(resp => {
          this.cargarEtiquetas(this.paginacionEtiquetas.paginacionParametros);
        }).catch(error => {
          console.log(error);
        });
      },
      editarEtiquetas: function (etiqueta) {
        this.newEtiquetas.etiqueta = etiqueta.etiqueta;
        this.newEtiquetas.cliente_id = etiqueta.cliente_id;
        this.newEtiquetas.id = etiqueta.id;
        this.paginacionEtiquetas.acciones.editar = true;
      },
      abrirSelectEtiqueta: function (categoria) {
        servicioApi.rol_regular.categorias.getUnaCategorias(categoria).then(resp => {
          categoria.etiquetas = resp.data.etiquetas;
        }).catch(e => {
        });
      },
      escogerEtiquetaParaguardar(categoria) {
        servicioApi.rol_regular.categorias.postEtiquetaCategorias(categoria).then(resp => {
          console.log(resp)
        }).catch(e => {
        })
      },
      limpiarEtiqueta() {
        this.paginacionEtiquetas.acciones.editar = false;
        this.newEtiquetas = {
          etiqueta: '',
          cliente_id: ''
        };
      },

      limpiar() {
        this.paginacionCategorias.acciones.editar = false;
        this.newcategoria = {
          categoria: '',
          cliente_id: ''
        };
      },
      editarCategoria: function (categoria) {
        this.newcategoria.categoria = categoria.categoria;
        this.newcategoria.cliente_id = categoria.cliente_id;
        this.newcategoria.id = categoria.id;
        this.paginacionCategorias.acciones.editar = true;
      },
      actualizarCategoria: function () {
        var data = new FormData();
        //Añadimos la imagen seleccionada
        console.log(this.newcategoria);
        console.log(this.newcategoria.id);
        //Añadimos la imagen seleccionada
        data.append('icono', this.imagen);
        data.append('cliente_id', this.cliente.id);
        data.append('categoria', this.newcategoria.categoria);
        //Añadimos el método PUT dentro del formData
        // Como lo hacíamos desde un formulario simple _(no ajax)_
        data.append('_method', 'PUT');
        servicioApi.rol_regular.categorias.putCategorias(data, this.newcategoria.id).then(resp => {
          this.imagen = null;
          this.cargarCategorias(this.paginacionCategorias.paginacionParametros);
          this.limpiar();
        }).catch(error => {
          console.log(error);
        });
      },
      eliminarCategoria: function (categoria) {
        servicioApi.rol_regular.categorias.deleteCategorias(categoria).then(resp => {
          console.log(resp.data.data);
          console.log(resp.status);

          if (resp.status == 202) {
            if (confirm(resp.data.data + '. \n Le recomendamos actualizar contenidos antes de eliminar esta categoria. \n ¿Desea eliminar la categoria y su contenido?')) {
              let parametro = {eliminar: true};
              categoria['parametro'] = parametro;
              servicioApi.rol_regular.categorias.deleteCategorias(categoria).then(resp => {
                if (resp.status == 200)
                  this.cargarCategorias(this.paginacionCategorias.paginacionParametros);
              }).catch(e => {
              });
            }
          } else if (resp.status == 200) {
            this.cargarCategorias(this.paginacionCategorias.paginacionParametros);
          }
          console.log(resp);
        }).catch(error => {
          console.log(error);
        });
      },
      getImage(event) {
        this.imagen = event.target.files[0];
      },
      guardarCategoria: function () {
        this.newcategoria.cliente_id = this.cliente.id;
        var data = new FormData();
        data.append('icono', this.imagen);
        data.append('cliente_id', this.cliente.id);
        data.append('categoria', this.newcategoria.categoria);
        data.append('_method', 'POST');
        servicioApi.rol_regular.categorias.postCategorias(data).then(resp => {
          this.newcategoria.categoria = '';
          this.newcategoria.cliente_id = '';
          this.imagen = null;
          this.cargarCategorias(this.paginacionCategorias.paginacionParametros)
        }).catch(error => {
          console.log(error);
        });
      },
      cargarCategorias(parametro) {
        if (parametro.page > this.categorias.last_page || parametro.page < 1)
          parametro.page = this.categorias.last_page;
        else {
          if (this.paginacionCategorias.selected != 'Mostrar') {
            parametro.mostrar = this.paginacionCategorias.selected;
          }
          this.paginacionCategorias.paginacionParametros = parametro;
          servicioApi.rol_regular.categorias.getCategorias(parametro).then(response => {
            this.cliente = response.data.data.cliente;
            this.categorias = response.data.data.categorias;
            if (this.categorias.current_page != undefined && this.categorias.current_page == 1)
              this.paginacionCategorias.paginacion.anterior = true;
            else
              this.paginacionCategorias.paginacion.anterior = false;

            if (this.categorias.current_page != undefined && this.categorias.last_page != undefined && this.categorias.last_page == this.categorias.current_page)
              this.paginacionCategorias.paginacion.siguiente = true;
            else
              this.paginacionCategorias.paginacion.siguiente = false;
          }).catch(e => {
          });
        }
      },
      paginarCategorias: function () {
        if (this.paginacionCategorias.selected != 'Mostrar') {
          this.cargarCategorias({mostrar: this.paginacionCategorias.selected});
        } else
          this.cargarCategorias({mostrar: null});
      }
    }
  }
</script>

<style scoped lang="scss">
  .bmd-layout-content {
    min-height: 90vh;
  }

  .botonAcciones {
    cursor: pointer;
  }

  .not-allowed {
    cursor: not-allowed !important;
  }

  .custom-file-label:after {
    bottom: 0;
    z-index: 3;
    display: initial;
    /*height: calc((2.4375rem + 2px) - 0 * 2);*/
    content: "";
    border-left: 0 solid rgba(0, 0, 0, .26);
    border-radius: 0 0 0 0;
  }

  .custom-file-label, .custom-file-label:after {
    position: initial !important;
    top: initial !important;
    right: initial !important;
    /*padding: .46875rem 1rem;*/
    line-height: initial !important;
    /*color: #495057;*/
    background-color: transparent;
  }

  .custom-select:focus {
    background-size: 8px 10px;
    border: 1px solid rgba(0, 0, 0, .26);
    border-radius: .125rem;
    -webkit-appearance: none;

    border-color: rgba(0, 0, 0, .26);
    -webkit-box-shadow: inset 0 1px 2px rgba(0, 0, 0, .075), 0 0 5px rgba(23, 255, 233, 0);
    box-shadow: inset 0 1px 2px rgba(0, 0, 0, .075), 0 0 5px rgba(23, 255, 233, 0);
  }

  .padreTabla {
    margin-top: -15px;
  }
</style>



// WEBPACK FOOTER //
// src/components/privada/regular/categorias/categorias.vue